import React from "react";
import { SadFace } from "@fidget/common/components/icons/sadFace/sadFace";
import { L10n } from "@fidget/common/i18n";
import { BeforeLoginSection } from "../components/beforeLoginSection";
import styles from "./loginOidcResponse.css";

export const LoginErrorSection = () => {
  return (
    <BeforeLoginSection styleType="login">
      <div className={styles["header-font"]}>
        <L10n id={"signup.error"} />
      </div>
      <SadFace className={styles["sad-icon"]} />
      <p className={styles["description-font"]}>
        <L10n id={"signup.error.description"} />
      </p>
    </BeforeLoginSection>
  );
};
